import React from 'react';

function EventImage({ src }) {
  return <img src={src} alt="Event flyer" style={{ width: '300px' }} />;
}

export default EventImage;
